import { ChangeDetectionStrategy, Component, computed, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BaseComponent } from '@core/base/base-component';

const ERROR_MESSAGES: Record<string, string> = {
  oauth_denied: 'Google sign-in was cancelled.',
  invalid_state: 'Your sign-in session expired. Please try again.',
  account_not_found: 'No account was found for this Google user. Please sign up first.',
  account_conflict: 'This Google account is already linked to another user.',
  invalid_request: 'The sign-in request was invalid. Please try again.',
  exchange_failed: 'We could not complete sign-in. Please try again.',
  oauth_failed: 'Google sign-in failed. Please try again.',
};

@Component({
  selector: 'app-google-error-page',
  imports: [RouterLink],
  templateUrl: './google-error-page.html',
  styleUrl: './google-error-page.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoogleErrorPage extends BaseComponent implements OnInit {
  private readonly errorCode = signal('oauth_failed');

  readonly message = computed(
    () => ERROR_MESSAGES[this.errorCode()] ?? ERROR_MESSAGES['oauth_failed'],
  );
  readonly isAccountNotFound = computed(
    () => this.errorCode() === 'account_not_found',
  );
  readonly currentYear = new Date().getFullYear();

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code') ?? 'oauth_failed';
    this.errorCode.set(code);
  }
}
